import React from "react";
import "./organization-discount-item.scss";

import { GSInfoGroup, GSButton } from "golfstatus_react_components";
import { faSitemap } from "@fortawesome/free-solid-svg-icons";

import { getDateTime } from "../../helpers/Dates";

const OrganizationDiscountItem = (props) => {
  const {
    description,
    code,
    discountDollarAmount,
    discountPercent,
    redeemedCount,
    remainingCodes,
    activateOn,
    deactivateOn,
    status,
  } = props;
  const getInfoGroup = () => {
    let infoSections = 
      {
        fit: "stretch",
        sections: [
          {
            sectionItems: [{ type: "primary", value: description }],
          },
          {
            sectionItems: [
              { type: "secondary", value: code },
              {
                type: "secondary",
                value: discountDollarAmount
                  ? `$${discountDollarAmount} off`
                  : `${discountPercent}% off`,
              },
            ],
          },
          {
            sectionItems: [
              {
                type: "secondary",
                value: remainingCodes
                  ? `${remainingCodes} Available`
                  : "Unlimited Use",
              },
              { type: "secondary", value: `${redeemedCount} Redeemed` },
            ],
          },
        ],
      }

    if (activateOn && deactivateOn) {
      infoSections.sections?.push?.({
        sectionItems: [
          {
            type: "secondary",
            value: `Activates on ${getDateTime(activateOn)}`,
          },
          {
            type: "secondary",
            value: `Deactivates on ${getDateTime(deactivateOn)}`,
          },
        ],
      });
    }

    return [
      {...infoSections},
      {
        sections: [
          {
            sectionItems: [
              { type: "primary", value: <GSButton buttonIcon={faSitemap} /> },
            ],
          },
        ],
      },
      {
        sections: [
          {
            sectionItems: [
              {
                type: "",
                value: (
                  <GSButton
                    type={`status secondary pill ${status}`}
                    title={status}
                  />
                ),
              },
            ],
          },
        ],
      },
    ];
  };
  return (
    <organization-discount-item>
      <GSInfoGroup  dataGroups={getInfoGroup()} />
    </organization-discount-item>
  );
};

export default OrganizationDiscountItem;
